


































































































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import {
  AchVerifier,
  HsabSsoDestination
} from "@/shared/types";
import SsoDeepLink from "@/shared/components/ui/SsoDeepLink.vue";
import Button from "@/shared/components/ui/Button.vue";
import { Validator } from "vee-validate";
import HsabLinkedAccountsList from "@/employee/components/settings/hsaBank/HsabLinkedAccountsList.vue";
import HsabMicroEntryVerificationAccountList from "@/employee/components/settings/hsaBank/HsabMicroEntryVerificationAccountList.vue";
import LinkedAccountsList from "./LinkedAccountsList.vue";
import MicroEntryVerificationAccountList from "./MicroEntryVerificationAccountList.vue";
import NewLinkedBankAccountForm from "./NewLinkedBankAccountForm.vue";
import LinkedAccountDefaults from "./LinkedAccountDefaults.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useBankAccountStore } from "@/employee/store/bankAccount";
import { usePartnerPortalStore } from "@/employee/store/partnerPortal";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";
import HsabExpenseEditModal from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseEditModal.vue";
import HsabExpenseForm from "@/employee/components/landing-pages/hsabank/expense/HsabExpenseForm.vue";
import { useThemeStore } from "@/shared/store/theme";

@Component({
  components: {
    HsabExpenseForm,
    HsabExpenseEditModal,
    Button,
    SsoDeepLink,
    LinkedAccountsList,
    HsabLinkedAccountsList,
    HsabMicroEntryVerificationAccountList,
    MicroEntryVerificationAccountList,
    NewLinkedBankAccountForm,
    LinkedAccountDefaults,
    GenericLoadingSpinner
  }
})
export default class LinkedBankAccounts extends Vue {
  $validator: Validator;
  observer = null;
  showModalBusy = false;

  isAddingUmbAccount = false;
  isRedirectedToWex = false;
  isLoadingAchVerifierUrl = false;
  isResyncInProgress = false;
  themeStore = useThemeStore();
  bankAccountStore = useBankAccountStore();
  partnerPortalStore = usePartnerPortalStore();
  custodianSettingStore = useCustodianSettingsStore();
  featureFlagStore = useFeatureFlagStore();
  hsabAccountsStore = useHsabAccountsStore();
  SsoDestination = HsabSsoDestination;

  get portalFunctionalityDisabled (): boolean {
    return this.custodianSettingStore.portalFunctionalityDisabled;
  }

  get areAccountsLinked () {
    return (this.bankAccountStore.linkedAccounts && this.bankAccountStore.linkedAccounts.length > 0) ||
        (this.bankAccountStore.microEntryVerificationAccounts &&
            this.bankAccountStore.microEntryVerificationAccounts.length > 0);
  }

  get isAddingAccount () {
    if (this.achVerifierIsUmb) {
      return this.isAddingUmbAccount;
    }

    if (this.achVerifierIsFinicity) {
      return this.bankAccountStore.isAchIFrameLoaded || this.isLoadingAchVerifierUrl;
    }

    return false;
  }
  get isDisabled (): boolean {
    return this.isAddingAccount || this.isConsumerLinkedAccountsInErrorState;
  }
  get isConsumerLinkedAccountsInErrorState (): boolean {
    return this.bankAccountStore.isConsumerLinkedAccountsInErrorState;
  }
  get accountLinkingRequiresPortalAccess () {
    return this.achVerifierIsUmb;
  }

  get unableToLinkDueToMissingPortalAccess () {
    return !this.partnerPortalStore.hasPortalAccess && this.accountLinkingRequiresPortalAccess;
  }

  get shouldShowAddAccountButton () {
    if (this.isConsumerLinkedAccountsInErrorState ||
        this.bankAccountStore.isAccountDelayInfoPanelLoaded ||
        (this.unableToLinkDueToMissingPortalAccess || this.bankAccountStore.linkedAccountIsLoading)
        || this.isNotionalOnlyAndHasDirectDepositAccount
        || this.isNotionalOnlyAndHasMissingUses) {
      return false;
    }

    return !this.isAddingAccount;
  }
  get shouldShowDeepLinkAccountButton () {
    return this.isHsaBankCustodian && this.shouldShowAddAccountButton
      && !this.featureFlagStore.flags.bend24268FinicityEnabledForHsab;
  }
  get achVerifierIsFinicity () {
    return this.bankAccountStore.achVerifier === AchVerifier.Finicity;
  }

  get achVerifierIsUmb () {
    return this.bankAccountStore.achVerifier === AchVerifier.Umb;
  }
  mounted () {
    this.bankAccountStore.loadBankAccountState(true);
    this.partnerPortalStore.getPartnerPortalStatus();
    if (this.isHsaBankCustodian) {
      this.hsabAccountsStore.getHsabAccounts();
    }
    this.$on("deep-link-click", event => {
      this.isRedirectedToWex = false;
    });
    // This component is hosted inside a component which ensures the linked bank account state has been fetched
    // If this component gets moved, that code should be added here
  }

  linkBankAccountClicked () {
    if (this.achVerifierIsFinicity) {
      this.addFinicityLinkedAccount();
    } else if (this.achVerifierIsUmb) {
      this.isAddingUmbAccount = true;
    }
  }

  umbAddAccountExitClicked (valueNotUsedYet: boolean) {
    this.isAddingUmbAccount = false;
  }

  addFinicityLinkedAccount () {
    if (this.isLoadingAchVerifierUrl) {
      return;
    }
    this.isLoadingAchVerifierUrl = true;
    this.bankAccountStore.retrieveAchVerifierUrl(window)
        .finally(() => this.isLoadingAchVerifierUrl = false);
  }

  closeDelayInfoPanel () {
    this.bankAccountStore.closeAccountDelayInfoPanel();
  }
  get isHsaBankCustodian () {
    return this.custodianSettingStore.isHsaBankCustodian;
  }
  onDeepLinkClick () {
    this.isRedirectedToWex = true;
  }
  get showLinkedAccountDefaults (): boolean {
    return !this.bankAccountStore.isAchIFrameLoaded
      && (!this.isHsaBankCustodian || this.featureFlagStore.flags.bend16612ContributionHandling);
  }
  get isHsaOnly (): boolean {
    return this.isHsaBankCustodian && this.hsabAccountsStore.isHsaOnly;
  }
  get isNotionalOnly (): boolean {
    return this.isHsaBankCustodian && this.hsabAccountsStore.isNotionalOnly;
  }
  get hasDirectDepositAccount (): boolean {
    return this.bankAccountStore.hasDirectDepositAccount;
  }
  get isNotionalOnlyAndHasDirectDepositAccount (): boolean {
    return this.isNotionalOnly && this.hasDirectDepositAccount;
  }
  get isNotionalOnlyAndHasMissingUses (): boolean {
    return this.isNotionalOnly && this.bankAccountStore.hasMissingUses;
  }
  get headerBlurb (): string {
    if (this.isNotionalOnly) {
      return "Move money from your account";
    }
    if (this.hsabAccountsStore.isHsaOnly) {
      return "Move money to and from your HSA";
    }
    return "Move money to and from your account";
  }
  get showRefreshButton (): boolean {
    return this.isRedirectedToWex
      && this.isHsaBankCustodian
      && !this.areAccountsLinked;
  }
  get awesomeClass (): string {
    return this.isResyncInProgress ? "fa-icon fa-spin" : "fa-icon";
  }
  reloadLinkedBankAccounts () {
    this.isResyncInProgress = true;
    this.isRedirectedToWex = false;
    this.bankAccountStore.reSyncLinkedBankAccounts()
      .finally(() => this.isResyncInProgress = false);
  }
  get showFinicityModal () {
    return this.custodianSettingStore.isHsaBankCustodian && this.bankAccountStore.isAchIFrameLoaded && !this.isLoadingAchVerifierUrl;
  }

  handleOnCloseFinicityModal () {
    this.showModalBusy = false;
    this.$nextTick( () => {
      if (this.observer) {
        this.observer.disconnect();
      }
    });
 }

  handleOnShowFinicityModal () {
    this.showModalBusy = true;
     this.$nextTick( () => {
       const targetNode  = this.$refs.iframeParent;
       // Create a MutationObserver instance
        const observer = new MutationObserver( mutations => {
          mutations.forEach( mutation => {
            this.showModalBusy = false;
            // Handle the content update here
          });
        });

        // Configuration for the observer
        const config = { childList: true, subtree: true, characterData: true };

        // Start observing the target node
        observer.observe(targetNode as Node, config);

        // Save the observer instance to clean up later
        this.observer = observer;
    });
  }
}
